import { createSelector } from 'reselect'

import { selectEmrVersionConfig } from 'selectors/selectEmrVersionConfig'

export const selectIsBootstrapAllowed = createSelector(
  [selectEmrVersionConfig],
  (emrVersionConfig) => emrVersionConfig.get('disable_bootstrap') !== 'yes'
)
